export default "__VITE_PUBLIC_ASSET__386b8bf7__"